module.exports = __webpack_public_path__ + "images/category_lp/common/reason1-woman-40@2x_28dbd14a6a42a4967a7d94a0bc862ce1.jpg";